/* unplugin-vue-components disabled */import script from "./ActionModals.vue?vue&type=script&setup=true&lang=ts"
export * from "./ActionModals.vue?vue&type=script&setup=true&lang=ts"

import "./ActionModals.vue?vue&type=style&index=0&id=7d90d40a&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7d90d40a"]])

export default __exports__